import { render, staticRenderFns } from "./ResDialog.vue?vue&type=template&id=ba360f74&scoped=true"
import script from "./ResDialog.vue?vue&type=script&lang=js"
export * from "./ResDialog.vue?vue&type=script&lang=js"
import style0 from "./ResDialog.vue?vue&type=style&index=0&id=ba360f74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba360f74",
  null
  
)

export default component.exports